import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { alternateLinks } from './alternate-links';

@Injectable({
  providedIn: 'root'
})
export class AlternateService {
  private readonly links: Array<{
    href: string;
    hreflang: string;
    link?: HTMLLinkElement;
  }> = alternateLinks;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.initAlternateLinks();
  }

  setAlternateURL(pathname: string): void {
    const pathnameWithoutLang = pathname.split('/').slice(2).join('/');

    this.links.forEach((link) => {
      link.link?.setAttribute('href', link.href + pathnameWithoutLang);
    });
  }

  initAlternateLinks(): void {
    this.links.forEach((link) => {
      link.link = this.document.createElement('link');
      link.link.setAttribute('rel', 'alternate');
      link.link.setAttribute('hreflang', link.hreflang);
      this.document.head.appendChild(link.link);
    });
  }
}
